import { render, staticRenderFns } from "./FormPopup.vue?vue&type=template&id=5ffc6c9a&scoped=true&"
import script from "./FormPopup.vue?vue&type=script&lang=js&"
export * from "./FormPopup.vue?vue&type=script&lang=js&"
import style0 from "./FormPopup.vue?vue&type=style&index=0&id=5ffc6c9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc6c9a",
  null
  
)

export default component.exports